import { AlignBottom, AlignMiddle, AlignTop } from '@styled-icons/bootstrap';
import { DreamBlock, VerticalAlignType } from '@typedream/core';
import { setNodes } from '@udecode/plate-core';
import classNames from 'classnames';
import { memo } from 'react';
import Tooltip from '../../../components/Tooltip';
import { DEFAULT_VERTICAL_ALIGN_TYPE } from '../../../constants';
import { useTPlateEditorRef } from '../../../plate';
import { getSelectedElementEntry } from '../../../plugins/elementSelection';
import { useDreamEditorStore } from '../../../plugins/store';
import styles from '../SideToolbar.module.css';

function VerticalAlign() {
  const editor = useTPlateEditorRef();

  const currentVerticalAlign = useDreamEditorStore(() => {
    const element = getSelectedElementEntry<Extract<DreamBlock, { vertical_align?: string }>>(
      editor,
    )?.[0];

    return element?.vertical_align || DEFAULT_VERTICAL_ALIGN_TYPE;
  });

  const setVerticalAlign = (v: VerticalAlignType) => {
    const path = getSelectedElementEntry(editor)?.[1];
    setNodes(editor, { vertical_align: v }, { at: path });
  };

  return (
    <div className={styles.section}>
      <span className={styles.label}>Vertical Align</span>
      <div className={styles.menuGroup}>
        <div className={styles.menuItem}>
          <Tooltip center="Align Top">
            <button
              type="button"
              className={classNames(styles.toggleButton, {
                [styles.active]: currentVerticalAlign === 'align_start',
              })}
              onClick={() => setVerticalAlign('align_start')}
            >
              <AlignTop size={16} />
            </button>
          </Tooltip>
          <Tooltip center="Align Middle">
            <button
              type="button"
              className={classNames(styles.toggleButton, {
                [styles.active]: currentVerticalAlign === 'align_center',
              })}
              onClick={() => setVerticalAlign('align_center')}
            >
              <AlignMiddle size={16} />
            </button>
          </Tooltip>
          <Tooltip center="Align Bottom">
            <button
              type="button"
              className={classNames(styles.toggleButton, {
                [styles.active]: currentVerticalAlign === 'align_end',
              })}
              onClick={() => setVerticalAlign('align_end')}
            >
              <AlignBottom size={16} />
            </button>
          </Tooltip>
        </div>
      </div>
    </div>
  );
}

export default memo(VerticalAlign);
